import Modal from 'react-modal';
import { IDeleteSpecialtiesInputModel } from 'inputModels';
import { ISolicitationViewModel, ISpecialtyViewModel } from 'viewModels';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import produce from 'immer';
import { useForm } from 'react-hook-form';
import { FormControl } from '@mui/material';
import { useTheme } from 'styled-components';
import { ContentModal, Header } from './style';
import { Button } from '../../Buttons/Button';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/IconDelete.svg';
import { ReactComponent as ExpandArrowIcon } from '../../../assets/icons/iconExpandArrow.svg';
import { useSpecialties } from '../../../context/specialties';
import { SelectControled } from '../../SelectControled';
import { CardOpenSolicitation } from '../../Cards/CardOpenSolicitation';

interface ModalDeleteSpecialtiesProps {
  isOpen: boolean;
  currentSpecialtySelected: ISpecialtyViewModel;
  onRequestClose: () => void;
  solicitationBySpecialty: ISolicitationViewModel[];
  onRequestRemoveSpecialty: (specialtiesDeleted: IDeleteSpecialtiesInputModel) => void;
}
export function ModalDeleteSpecialties({
  isOpen,
  currentSpecialtySelected,
  onRequestClose,
  onRequestRemoveSpecialty,
  solicitationBySpecialty,
}: ModalDeleteSpecialtiesProps) {
  const theme = useTheme();
  const [specialtiesId, setSpecialtiesId] = useState('');
  const { specialties } = useSpecialties();

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
        maxHeight: 250,
      },
    },
  };
  const close = () => {
    setSpecialtiesId('');
    onRequestClose();
  };
  const [defaultValues] = useState<ISpecialtyViewModel>({
    id: '',
    name: '',
  });
  const handleOnMouseOverCard = (row: number, column: number) => {
    setHasHoverCard(
      produce((draft) => {
        let newDraft = draft[row][column];
        newDraft = true;
        return newDraft;
      }),
    );
  };
  const handleOnMouseOutCard = (row: number, column: number) => {
    setHasHoverCard(
      produce((draft) => {
        let newDraft = draft[row][column];
        newDraft = false;
        return newDraft;
      }),
    );
  };

  const [hasHoverCard, setHasHoverCard] = useState<boolean[][]>(() => {
    return Array(...Array(24)).map(() => {
      return Array(...Array(31)).map(() => false);
    });
  });

  const { control } = useForm({
    reValidateMode: 'onChange',
    defaultValues,
  });
  const confirmRemoveSpecialty = () => {
    const specialtyDeleted: IDeleteSpecialtiesInputModel = {
      id: currentSpecialtySelected.id,
      to: specialtiesId,
    };
    onRequestRemoveSpecialty(specialtyDeleted);
    setSpecialtiesId('');
    onRequestClose();
  };
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      overlayClassName="react-modal-overlay"
      className="react-delete-modal-content">
      <Header>
        <div className="subHeader">
          <DeleteIcon />
          <h1>Exclusão</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={close}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <div className="contentFlex">
          <h2 className="confirmationText">
            Tem certeza que quer excluir o serviço de correspondência?
            <p>{currentSpecialtySelected.name}</p>
          </h2>
        </div>
        {solicitationBySpecialty.length > 0 && (
          <>
            <h2 className="confirmationText">
              Ele está vinculado a solicitações, você deseja alterar o serviço de correspondência?
            </h2>
            <div>
              <div className="divDropDownList">
                <FormControl fullWidth>
                  <SelectControled
                    name="NewSpecialtiesId"
                    control={control}
                    displayEmpty
                    classes={{ select: 'select-style' }}
                    value={specialtiesId}
                    onChange={(el) => setSpecialtiesId(`${el.target.value}`)}
                    MenuProps={MenuProps}
                    IconComponent={ExpandArrowIcon}
                    itens={specialties
                      .filter((specialty) => specialty.id !== currentSpecialtySelected.id)
                      .map((specialty) => ({ id: specialty.id, value: specialty.name }))}
                    placeholderTitle="Selecione"
                  />
                </FormControl>
              </div>
            </div>
            <div className="contentSolicitations">
              <p className="info">Solicitações abertas ou em andamento</p>
              <div className="contentSolicitationOpened">
                {solicitationBySpecialty.map((solicitation, index) => {
                  return (
                    <CardOpenSolicitation
                      key={solicitation.id}
                      onMouseLeave={() => handleOnMouseOutCard(1 + index, index)}
                      onMouseEnter={() => handleOnMouseOverCard(1 + index, index + 1)}
                      zIndex={solicitationBySpecialty.length - index}
                      left={hasHoverCard[1][1] ? index * 91 : index * 15}
                      solicitation={solicitation}
                    />
                  );
                })}
              </div>
            </div>
            <p className="confirmationText">
              Ps.: Solicitações finalizadas permanecerão com o nome do Serviço.
            </p>
          </>
        )}
        <div className="buttonModal">
          <Button
            text="Cancelar"
            dimensions={{ width: '10rem', height: '2.25rem' }}
            onClick={close}
          />
          <Button
            text="Excluir"
            dimensions={{ width: '10rem', height: '2.25rem' }}
            onClick={confirmRemoveSpecialty}
            disabled={solicitationBySpecialty.length > 0 && !(specialtiesId.length > 2)}
          />
        </div>
      </ContentModal>
    </Modal>
  );
}
